import { useNavigate } from 'react-router-dom'
import PATHS from '@/routes/paths'
import { NAV_MODE } from './navMode.js'
import { useHomeNavMode } from './useHomeNavMode'

/** Chat/Pulse tabs also switch the main page, not only the rail list. */
export function useHomeNavModeSwitch(automationSurfaceActive, { onPulse, onChat }) {
  const navigate = useNavigate()
  const { mode, setMode } = useHomeNavMode(automationSurfaceActive)

  const onChange = (next) => {
    if (next === NAV_MODE.PULSE) {
      setMode(next)
      if (onPulse) onPulse()
      else navigate(PATHS.PULSE)
      return
    }
    if (next === mode) return
    setMode(next)
    if (onChat) onChat()
    else navigate(PATHS.HOME)
  }

  return { mode, onChange }
}
